import { createSelector } from '@reduxjs/toolkit'
import { TRootState } from 'store/types'

const selector = (state: TRootState) => state.voiceCatalog

const isLanguageOptionsLoading = createSelector(
  selector,
  state => state.languageOptions.isLoading
)

const languageOptionsData = createSelector(
  selector,
  state => state.languageOptions.data
)

const isAvatarLanguageOptionsLoading = createSelector(
  selector,
  state => state.avatarLanguageOptions.isLoading
)

const avatarLanguageOptionsData = createSelector(
  selector,
  state => state.avatarLanguageOptions.data
)

const speakersPerLangCode = createSelector(
  selector,
  state => state.speakersPerLangCode
)

const makeSpeakersSelectorPerLangCode = () =>
  createSelector(
    [selector, (_state: TRootState, langCode: string) => langCode],
    (catalogState, langCode) =>
      catalogState.speakersPerLangCode?.[langCode]?.data || null
  )

const makeSpeakersPerLangCodeIsLoadingSelector = () =>
  createSelector(
    [selector, (_state: TRootState, langCode: string) => langCode],
    (catalogState, langCode) =>
      catalogState.speakersPerLangCode?.[langCode]?.isLoading || false
  )

const speakersPerLangCodeSelector = makeSpeakersSelectorPerLangCode()
const speakersPerLangCodeIsLoadingSelector =
  makeSpeakersPerLangCodeIsLoadingSelector()

const speakerTones = createSelector(selector, state => state.speakerTones.data)

const isSpeakerTonesLoading = createSelector(
  selector,
  state => state.speakerTones.isLoading
)

export const voiceCatalogSelectors = {
  isLanguageOptionsLoading,
  languageOptionsData,
  isAvatarLanguageOptionsLoading,
  avatarLanguageOptionsData,
  speakersPerLangCode,
  speakersPerLangCodeSelector,
  speakersPerLangCodeIsLoadingSelector,
  speakerTones,
  isSpeakerTonesLoading
}
